export enum MetricsPeriodType {
	CURRENT_MONTH = "currentMonth",
	PAST_MONTH = "pastMonth",
	CURRENT_QUARTER = "currentQuarter",
	PAST_QUARTER = "pastQuarter",
	CURRENT_YEAR = "currentYear",
	PAST_YEAR = "pastYear",
	ALL_TIME = "allTime",
	PERIOD = "period"
}
